import type { SourcePropertyDefinition } from './types';

export type MappingFormatToken =
  | { kind: 'text'; text: string; start: number; end: number }
  | { kind: 'source'; text: string; sourceProperty: string; raw: string; start: number; end: number };

/** 입력 문자열의 UTF-16 위치와 escape를 유지하며 확인된 속성만 구분한다. */
export function tokenizeFormatText(text: string, sources: SourcePropertyDefinition[]): MappingFormatToken[] {
  const sourcesByLabel = new Map<string, SourcePropertyDefinition[]>();
  for (const source of sources) {
    const label = source.label.trim();
    sourcesByLabel.set(label, [...sourcesByLabel.get(label) ?? [], source]);
  }
  const tokens: MappingFormatToken[] = [];
  let textStart = 0;
  let index = 0;
  while (index < text.length) {
    if (text[index] === '\\') {
      if (text[index + 1] === '\\') { index += 2; continue; }
      if (text.startsWith('{{', index + 1)) { index += 3; continue; }
    }
    if (!text.startsWith('{{', index)) { index += 1; continue; }
    const closingIndex = text.indexOf('}}', index + 2);
    if (closingIndex < 0) break;
    const end = closingIndex + 2;
    const matches = sourcesByLabel.get(text.slice(index + 2, closingIndex).trim());
    if (matches?.length === 1) {
      if (textStart < index) tokens.push({ kind: 'text', text: text.slice(textStart, index), start: textStart, end: index });
      tokens.push({ kind: 'source', text: matches[0].label, sourceProperty: matches[0].key, raw: text.slice(index, end), start: index, end });
      textStart = end;
    }
    index = end;
  }
  if (textStart < text.length) tokens.push({ kind: 'text', text: text.slice(textStart), start: textStart, end: text.length });
  return tokens;
}
